module.exports = __webpack_public_path__ + "static/media/hp.bae28d22.png";